import { FF_STORAGE, FF_NAME } from "../config/feature-flags.js";

export function featureEnabled(name) {
    const flags = JSON.parse(FF_STORAGE.getItem(`${FF_NAME}-repo`) || "[]");

    const flag = flags.find((flag) => flag.name === name);

    let enabled = false;
    if (flag) {
        enabled = flag.enabled;
    }

    return enabled;
}
